import { MutationTree } from 'vuex'
import { NarrowcastingState } from '@/store/narrowcasting/index'
import {
    WinckCollection, WinckFilterConfig,
    WinckOffice,
    WinckScheduledCollection,
    WinckScreen,
} from '@/api/client/winck-proxy'
import Vue from 'vue'


export const mutations: MutationTree<NarrowcastingState> = {
    loadData(state: NarrowcastingState): void {
        state.loading = true
        state.error = null
    },
    loadDataSuccess(state: NarrowcastingState, result: { collections: WinckCollection[], scheduledCollections: WinckScheduledCollection[], offices: WinckOffice[], screens: WinckScreen[], filterConfigs: WinckFilterConfig[] }): void {
        state.loading = false
        state.error = null
        state.collections = result.collections
        state.scheduledCollections = result.scheduledCollections
        state.offices = result.offices
        state.screens = result.screens
        state.filterConfigs = result.filterConfigs
    },
    loadDataFailure(state: NarrowcastingState, error: string): void {
        state.loading = false
        state.error = error
    },

    sortData(state: NarrowcastingState): void {
        state.collections.sort(((a, b) => a.name.localeCompare(b.name)))
        state.scheduledCollections.sort(((a, b) => a.collection.name.localeCompare(b.collection.name)))
        state.offices.sort(((a, b) => a.name.localeCompare(b.name)))
        state.screens.sort(((a, b) => a.name.localeCompare(b.name)))
    },

    createCollection(state: NarrowcastingState): void {
        state.saving = true
        state.error = null
    },
    createCollectionSuccess(state: NarrowcastingState, collection: WinckCollection): void {
        state.saving = false
        state.error = null
        state.collections.push(collection)
    },
    createCollectionFailure(state: NarrowcastingState, error: string): void {
        state.saving = false
        state.error = error
    },
    editCollection(state: NarrowcastingState): void {
        state.saving = true
        state.error = null
    },
    editCollectionSuccess(state: NarrowcastingState, collection: WinckCollection): void {
        state.saving = false
        state.error = null

        const index  = state.collections.findIndex(v => v.id === collection.id)
        if (index >= 0) {
            Vue.set(state.collections, index, collection)
        }
    },
    editCollectionFailure(state: NarrowcastingState, error: string): void {
        state.saving = false
        state.error = error
    },
    deleteCollection(state: NarrowcastingState): void {
        state.saving = true
        state.error = null
    },
    deleteCollectionSuccess(state: NarrowcastingState, collection: WinckCollection): void {
        state.saving = false
        state.error = null
        state.collections.splice(state.collections.findIndex(v => v.id === collection.id), 1)
    },
    deleteCollectionFailure(state: NarrowcastingState, error: string): void {
        state.saving = false
        state.error = error
    },

    createScheduledCollection(state: NarrowcastingState): void {
        state.saving = true
        state.error = null
    },
    createScheduledCollectionSuccess(state: NarrowcastingState, scheduledCollection: WinckScheduledCollection): void {
        state.saving = false
        state.error = null
        state.scheduledCollections.push(scheduledCollection)
    },
    createScheduledCollectionFailure(state: NarrowcastingState, error: string): void {
        state.saving = false
        state.error = error
    },
    editScheduledCollection(state: NarrowcastingState): void {
        state.saving = true
        state.error = null
    },
    editScheduledCollectionSuccess(state: NarrowcastingState, scheduledCollection: WinckScheduledCollection): void {
        state.saving = false
        state.error = null

        const index  = state.scheduledCollections.findIndex(v => v.id === scheduledCollection.id)
        if (index >= 0) {
            Vue.set(state.scheduledCollections, index, scheduledCollection)
        }
    },
    editScheduledCollectionFailure(state: NarrowcastingState, error: string): void {
        state.saving = false
        state.error = error
    },
    deleteScheduledCollection(state: NarrowcastingState): void {
        state.saving = true
        state.error = null
    },
    deleteScheduledCollectionSuccess(state: NarrowcastingState, scheduledCollection: WinckScheduledCollection): void {
        state.saving = false
        state.error = null
        state.scheduledCollections.splice(state.scheduledCollections.findIndex(v => v.id === scheduledCollection.id), 1)
    },
    deleteScheduledCollectionFailure(state: NarrowcastingState, error: string): void {
        state.saving = false
        state.error = error
    },

    createOffice(state: NarrowcastingState): void {
        state.saving = true
        state.error = null
    },
    createOfficeSuccess(state: NarrowcastingState, office: WinckOffice): void {
        state.saving = false
        state.error = null
        state.offices.push(office)
    },
    createOfficeFailure(state: NarrowcastingState, error: string): void {
        state.saving = false
        state.error = error
    },
    editOffice(state: NarrowcastingState): void {
        state.saving = true
        state.error = null
    },
    editOfficeSuccess(state: NarrowcastingState, office: WinckOffice): void {
        state.saving = false
        state.error = null

        const index  = state.offices.findIndex(v => v.id === office.id)
        if (index >= 0) {
            Vue.set(state.offices, index, office)
        }
    },
    editOfficeFailure(state: NarrowcastingState, error: string): void {
        state.saving = false
        state.error = error
    },
    deleteOffice(state: NarrowcastingState): void {
        state.saving = true
        state.error = null
    },
    deleteOfficeSuccess(state: NarrowcastingState, office: WinckOffice): void {
        state.saving = false
        state.error = null
        state.offices.splice(state.offices.findIndex(v => v.id === office.id), 1)
    },
    deleteOfficeFailure(state: NarrowcastingState, error: string): void {
        state.saving = false
        state.error = error
    },

    createScreen(state: NarrowcastingState): void {
        state.saving = true
        state.error = null
    },
    createScreenSuccess(state: NarrowcastingState, screen: WinckScreen): void {
        state.saving = false
        state.error = null
        state.screens.push(screen)
    },
    createScreenFailure(state: NarrowcastingState, error: string): void {
        state.saving = false
        state.error = error
    },
    editScreen(state: NarrowcastingState): void {
        state.saving = true
        state.error = null
    },
    editScreenSuccess(state: NarrowcastingState, screen: WinckScreen): void {
        state.saving = false
        state.error = null

        const index  = state.screens.findIndex(v => v.id === screen.id)
        if (index >= 0) {
            Vue.set(state.screens, index, screen)
        }
    },
    editScreenFailure(state: NarrowcastingState, error: string): void {
        state.saving = false
        state.error = error
    },
    deleteScreen(state: NarrowcastingState): void {
        state.saving = true
        state.error = null
    },
    deleteScreenSuccess(state: NarrowcastingState, screen: WinckScreen): void {
        state.saving = false
        state.error = null
        state.screens.splice(state.screens.findIndex(v => v.id === screen.id), 1)
    },
    deleteScreenFailure(state: NarrowcastingState, error: string): void {
        state.saving = false
        state.error = error
    },
}
